import { useState, useEffect } from "react";
import { useAdmin } from "@/hooks/useAdmin";
import { useExcludedIP } from "@/hooks/useExcludedIP";

export const DebugOverlay = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdmin();
  const { isExcluded: isExcludedIP, isChecking: isCheckingIP } = useExcludedIP();
  const [isVisible, setIsVisible] = useState(false);
  const [sessionId, setSessionId] = useState("");

  useEffect(() => {
    setSessionId(sessionStorage.getItem("session_id") || "none");
  }, []);

  // Show debug on double-tap bottom-right corner
  useEffect(() => {
    let tapCount = 0;
    let tapTimeout: ReturnType<typeof setTimeout>;

    const handleClick = (e: MouseEvent) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;

      // Check if click is in bottom-right corner (100px x 100px)
      if (clientX > innerWidth - 100 && clientY > innerHeight - 100) {
        tapCount++;
        clearTimeout(tapTimeout);

        if (tapCount === 3) {
          setIsVisible(!isVisible);
          tapCount = 0;
        }

        tapTimeout = setTimeout(() => {
          tapCount = 0;
        }, 500);
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
      clearTimeout(tapTimeout);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 left-4 z-[9999] bg-black/90 text-white p-4 rounded-lg text-xs font-mono max-w-sm">
      <div className="flex justify-between items-center mb-2">
        <span className="font-bold">Debug Info</span>
        <button onClick={() => setIsVisible(false)} className="text-red-400">✕</button>
      </div>
      <div className="space-y-1">
        <div>Session: {sessionId.substring(0, 20)}...</div>
        <div>Admin Loading: {isAdminLoading ? "⏳ YES" : "✓ NO"}</div>
        <div>Is Admin: {isAdmin ? "🔒 YES" : "✓ NO"}</div>
        <div>IP Checking: {isCheckingIP ? "⏳ YES" : "✓ NO"}</div>
        <div>IP Excluded: {isExcludedIP ? "🚫 YES" : "✓ NO"}</div>
        <div className="pt-2 border-t border-white/20">
          <div className="font-bold">Should Track?</div>
          <div>{!isAdmin && !isExcludedIP && !isAdminLoading && !isCheckingIP ? "✅ YES" : "❌ NO"}</div>
        </div>
        <div className="pt-2 text-[10px] text-white/60">
          Triple-tap bottom-right to toggle
        </div>
      </div>
    </div>
  );
};
